var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 31,
    viewBox: "0 0 112 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.573C7.44738 24.573 3.72369 6.42682 7.44738 6.42682C3.72369 6.42682 3.72369 24.573 0 24.573Z",
    fill: "url(#paint0_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44739 6.42682C12.0504 6.42682 12.5335 24.8661 16.0727 29.8003C15.7253 30.5657 15.3344 30.9999 14.8948 30.9999C11.1657 30.9999 11.1657 6.42682 7.44739 6.42682Z",
    fill: "url(#paint1_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8893 31C22.3367 31 18.613 0 22.3367 0C18.613 0 18.613 31 14.8893 31Z",
    fill: "url(#paint2_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3367 0C26.9398 0 27.5586 24.8662 31.0923 29.8004C30.7123 30.5603 30.2781 31 29.7787 31C26.0604 31 26.0604 0 22.3367 0Z",
    fill: "url(#paint3_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6789 24.573C37.2315 24.573 40.9552 6.42682 37.2315 6.42682C40.9498 6.42682 40.9498 24.573 44.6789 24.573Z",
    fill: "url(#paint4_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0977 29.8003C30.7178 30.5602 30.2835 30.9999 29.7841 30.9999C37.2315 30.9999 33.5078 6.42682 37.2315 6.42682C34.0072 6.42682 33.5729 24.8661 31.0977 29.8003Z",
    fill: "url(#paint5_linear_2476_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2492 21.0014C57.6955 21.4031 57.0224 21.7722 55.8391 21.7722C53.5321 21.7722 52.0991 20.0841 52.0991 17.3592C52.0991 14.5366 53.4724 12.919 55.8717 12.919C56.9084 12.919 57.5055 13.1958 58.1298 13.6409L58.2003 13.6898L58.4446 13.4075L58.3632 13.3478C57.8041 12.9353 57.1093 12.5499 55.8608 12.5499C53.2445 12.5499 51.6812 14.3466 51.6812 17.3592C51.6812 20.3121 53.2716 22.1468 55.8337 22.1468C57.1907 22.1468 58.0049 21.6637 58.4989 21.3L58.5803 21.2403L58.3197 20.9526L58.2492 21.0014Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8039 16.8976H61.1207V12.6854H60.7081V22.0164H61.1207V17.2668H66.8039V22.0164H67.211V12.6854H66.8039V16.8976Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3418 12.6854H70.9293V22.0164H71.3418V12.6854Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4835 12.6854H75.0709V22.0164H79.9128L79.9888 21.6418H75.4835V12.6854Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9792 13.06H82.2741V22.0164H82.6866V13.06H85.9706L86.0357 12.6854H78.9792V13.06Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4404 17.2668H92.4355V16.9031H88.4404V13.0545H93.0706L93.1248 12.6854H88.0333V22.0164H93.2388V21.6473H88.4404V17.2668Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.582 15.1444C101.582 13.4888 100.431 12.6854 98.0536 12.6854H95.7141V22.0164H96.1266V17.6087H98.6615L101.598 22.0164H102.108L99.1229 17.5707C100.713 17.3428 101.582 16.4905 101.582 15.1444ZM101.164 15.1444C101.164 17.0388 99.2586 17.245 98.4444 17.245H96.132V13.0545H98.0319C100.171 13.0545 101.164 13.7168 101.164 15.1444Z",
    fill: "#0E0F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.076 12.6855H110.669V19.5466C110.669 20.2523 110.679 20.8982 110.69 21.3867L105.018 12.7289L104.991 12.6855H104.752L104.736 12.6583V12.6855H104.562V22.0164H104.969V14.9924C104.969 14.1891 104.964 13.6951 104.953 13.3314L110.631 21.9784L110.658 22.0218H110.891L110.902 22.0381V22.0218H111.087V12.6855H111.076Z",
    fill: "#0E0F11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2476_150",
    x1: 3.72293,
    y1: 24.5728,
    x2: 3.72293,
    y2: 6.42725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B9DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#672D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2476_150",
    x1: 11.7581,
    y1: 31.0014,
    x2: 11.7581,
    y2: 6.42725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE444F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C84196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63469B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2476_150",
    x1: 18.6147,
    y1: 31.0015,
    x2: 18.6147,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E44F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#E84D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2294,
    stopColor: "#EC4C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3604,
    stopColor: "#EE4B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EF4B28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2476_150",
    x1: 26.7174,
    y1: 31.0015,
    x2: 26.7174,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBDD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2476_150",
    x1: 40.954,
    y1: 24.5728,
    x2: 40.954,
    y2: 6.42725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69CDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0238,
    stopColor: "#5FCAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1143,
    stopColor: "#3DC0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2067,
    stopColor: "#22B9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3007,
    stopColor: "#0FB3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3972,
    stopColor: "#04B0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00AFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC09A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2476_150",
    x1: 33.5078,
    y1: 31.0014,
    x2: 33.5078,
    y2: 6.42725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0132,
    stopColor: "#BAD537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1293,
    stopColor: "#A0CD49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#8DC756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3701,
    stopColor: "#82C45D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7EC360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.076,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c33f37ac121656090ac0d2ee704245d6.svg";
export { ForwardRef as ReactComponent };